<template>
  <div class="rounded-2xl overflow-hidden border border-surface-200 bg-white shadow-[0_6px_18px_rgba(0,0,0,.07)]">
    <!-- Hero — mirrors the live business page: soft tinted header, centered logo card -->
    <div class="text-center px-3.5 pt-4 pb-3" :style="{ background: `linear-gradient(180deg, ${color}24, ${color}0a)` }">
      <img
        v-if="logoImage"
        :src="logoImage"
        alt="לוגו"
        class="w-[52px] h-[52px] rounded-xl object-cover inline-block bg-white shadow-[0_3px_10px_rgba(0,0,0,.09)]"
      />
      <div
        v-else
        class="w-[52px] h-[52px] rounded-xl bg-white shadow-[0_3px_10px_rgba(0,0,0,.09)] inline-flex items-center justify-center text-[17px] font-bold"
        :style="{ color }"
      >{{ initials }}</div>
      <div class="text-[15px] font-bold mt-2">{{ title || 'שם העסק' }}</div>
      <div v-if="subtitle" class="text-[11px] text-surface-500 mt-0.5">{{ subtitle }}</div>
      <div class="flex justify-center items-center gap-2 mt-2.5">
        <div class="px-5 py-[7px] rounded-full text-white text-[11.5px] font-semibold" :style="{ background: color }">קביעת תור</div>
        <div class="w-[30px] h-[30px] rounded-full bg-white flex items-center justify-center" :style="{ border: `1.5px solid ${color}55` }">
          <i class="pi pi-phone text-[11px]" :style="{ color }" />
        </div>
      </div>
    </div>
    <div class="px-3.5 pt-2.5 pb-3">
      <div v-if="categories?.length" class="flex gap-1.5 mb-2 overflow-hidden">
        <span
          v-for="(category, i) in categories"
          :key="category"
          class="text-[10px] px-2.5 py-[3px] rounded-full whitespace-nowrap border"
          :class="i === 0 ? 'text-white border-transparent' : 'bg-white text-surface-600 border-surface-200'"
          :style="i === 0 ? { background: color } : {}"
        >{{ category }}</span>
      </div>
      <div class="text-[10.5px] text-surface-500 flex items-center gap-1 whitespace-nowrap overflow-hidden">
        <i class="pi pi-map-marker text-[10px] text-surface-400 flex-none" />
        {{ [address, phone].filter(Boolean).join(' · ') }}
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

const props = defineProps<{
  color: string;
  title?: string;
  subtitle?: string;
  logoImage?: string;
  address?: string;
  phone?: string;
  categories?: string[];
}>();

const initials = computed(() =>
  (props.title || '').split(' ').filter(Boolean).slice(0, 2).map(w => w[0]).join('')
);
</script>
